export default __webpack_public_path__ + "static/media/noreview.4c56fec0.svg";